import { CustomField } from '../dictionary-service';
import { ExternalPublication } from './vacancy-helpers.interface';

export enum PublishedStatus {
  UNPUBLISHED = 0,
  PUBLISHED = 1,
  NOT_DEFINED = 2,
}

export interface Query {
  address: string;
  /**
   * With it, `recruiters` matches the vacancy's assignee only. Without it the
   * filter also matches assisting recruiters.
   */
  assignedOnly?: boolean;
  endDate: string;
  /** Keep only vacancies with no activity for this many days or longer. */
  idleDays?: number;
  includeArchived: boolean;
  keywords?: string;
  managers: string[];
  onlyHotVacancies: boolean;
  pageNumber: number;
  pageSize: number;
  publishedStatus: PublishedStatus;
  recruiters: number[];
  sortDirection: 'asc' | 'desc';
  sortField: string;
  startDate: string;
  vacancyStatuses: number[];
}
export interface RecruiterQuery {
  keyword?: string;
}
export interface PublicQuery {
  business?: number[];
  category?: number[];
  city?: number;
  country?: number;
  keywords?: string[];
  onlyHotVacancies?: boolean;
  pageSize: number;
  pageNumber: number;
  portalIds?: number[];
  portalIdExceptions?: number[];
  region?: number[];
  skills?: number[];
  vacancyStatuses: number[];
}

export interface StatisticQuery {
  readonly dateFrom: Date;
  readonly dateTo: Date;
  readonly recruiterId?: number;
}

export interface PatchPayload {
  id: number;
  assignedId?: number;
  status?: number;
  isVisible?: boolean;
}
export interface Payload {
  archived: boolean;
  assignedId: number;
  cityId: number | null;
  countryId: number | null;
  currency: string | null;
  currentStatus: number;
  customFields: CustomField.Item[];
  deadlineDate: Date | null;
  department: string | null;
  description: string | null;
  durationId: number | null;
  employmentId: number | null;
  externalPublications: ExternalPublication[];
  firstCvSentAt: Date | null;
  firstHireAt: Date | null;
  firstInterviewAt: Date | null;
  hotVacancy: boolean;
  id?: number;
  insideInformation: string | null;
  levelId: number | null;
  mainSkill: number | null;
  name: string;
  numbersOfTalent: number;
  rate: number | null;
  recruiterFavorites: number[];
  salary: string | null;
  salaryComment: string | null;
  showInPublicWebsite: boolean;
  skills: number[];
  specialityId: number | null;
  startDate: Date | null;
  successClosedDate: Date | null;
  unsuccessClosedDate: Date | null;
}
export interface ProcessGroupVacancies {
  date: Date;
}

/**
 * `POST vacancies/transfer`: hand a recruiter's unclosed vacancies to another
 * one. User ids — the same space as `project.assigned_id`.
 */
export interface TransferPayload {
  fromUserId: number;
  toUserId: number;
}

/** `GET vacancies/assigned-count?userId=`: whose unclosed vacancies to count. */
export interface AssignedCountQuery {
  userId: number;
}
